export default function()
{
    const self = this;

    /**
     * The times to filter with
     * @type {Array}
     */
    self.filterTimes = (() => {
        const allTimes = [
            { value: 'morning', label: 'Ochtend' },
            { value: 'afternoon', label: 'Middag' },
            { value: 'evening', label: 'Avond' },
        ];

        const now = new Date();
        const filterTimes = [];

        // Morning
        if (now.getHours() < 12) {
            filterTimes.push(allTimes[0]);
        }

        // Afternoon
        if (now.getHours() < 18) {
            filterTimes.push(allTimes[1]);
        }

        // Evening
        filterTimes.push(allTimes[2]);

        return filterTimes;
    })();

    /**
     * The screens to filter with
     * @type {Array}
     */
    self.filterScreens = [
        { value: 'imax', label: 'IMAX' },
        { value: '2d', label: '2D' },
        { value: '3d', label: '3D' },
        { value: '4d', label: '4D' },
    ];

    /**
     * The options to sort movies with
     * @type {Array}
     */
    self.homeMovieSortingOptions = [
        { value: 'popularity_desc', label: 'Populariteit (hoog > laag)' },
        { value: 'popularity_asc', label: 'Populariteit (laag > hoog)' },
        { value: 'time_asc', label: 'Tijd (vroeg > laat)' },
        { value: 'time_desc', label: 'Tijd (laat > vroeg)' },
        { value: 'title_asc', label: 'Titel (A > Z)' },
        { value: 'title_desc', label: 'Titel (Z > A)' },
        { value: 'age_desc', label: 'Film (nieuw > oud)' },
        { value: 'age_asc', label: 'Film (oud > nieuw)' },
    ];

    /**
     * The options to sort the movies overview with
     * @type {Array}
     */
    self.moviesOverviewSortingOptions = [
        { value: 'title_asc', label: 'Titel (A > Z)' },
        { value: 'title_desc', label: 'Titel (Z > A)' },
        { value: 'age_desc', label: 'Film (nieuw > oud)' },
        { value: 'age_asc', label: 'Film (oud > nieuw)' },
    ];

    /**
     * The options to sort cinemas with
     * @type {Array}
     */
    self.cinemaSortingOptions = [
        { value: 'name_asc', label: 'Naam (A > Z)' },
        { value: 'name_desc', label: 'Naam (Z > A)' },
    ];

    /**
     * The days to filter movies with
     * @type {Array}
     */
    self.filterDays = window.filterDays || [];

    /**
     * Default image paths
     * @type {Object}
     */
    self.imagePaths = {
        movieSmall: $('meta[name="movie-placeholder-small"]').attr('content'),
        cinemaSmall: $('meta[name="cinema-placeholder-small"]').attr('content'),
    };

    /**
     * Genres to filter movies with
     * @type {Array}
     */
    self.filterGenres = [
        { value: 'actie', label: 'Actie' },
        { value: 'crime', label: 'Crime' },
        { value: 'drama', label: 'Drama' },
        { value: 'humor', label: 'Humor' },
        { value: 'misdaad', label: 'Misdaad' },
        { value: 'thriller', label: 'Thriller' },
        { value: 'fantasy', label: 'Fantasy' },
        { value: 'horror', label: 'Horror' },
        { value: 'avontuur', label: 'Avontuur' },
        { value: 'levensbeschouwelijk', label: 'Levensbeschouwelijk' },
        { value: 'mystery', label: 'Mystery' },
        { value: 'sci-fi', label: 'Sci-fi' },
        { value: 'science fiction', label: 'Science fiction' },
        { value: 'sciencefiction', label: 'Sciencefiction' },
        { value: 'animation', label: 'Animation' },
        { value: 'short', label: 'Short' },
        { value: 'history', label: 'History' },
        { value: 'action', label: 'Action' },
        { value: 'adventure', label: 'Adventure' },
        { value: 'animatie', label: 'Animatie' },
        { value: 'comedy', label: 'Comedy' },
        { value: 'familiefilm', label: 'Familiefilm' },
        { value: 'family', label: 'Family' },
        { value: 'komedie', label: 'Komedie' },
        { value: 'documentaire', label: 'Documentaire' },
        { value: 'documentary', label: 'Documentary' },
        { value: 'biografie', label: 'Biografie' },
        { value: 'biography', label: 'Biography' },
        { value: 'war', label: 'War' },
        { value: 'kunst', label: 'Kunst' },
        { value: 'oorlog', label: 'Oorlog' },
        { value: 'romantiek', label: 'Romantiek' },
        { value: 'familie', label: 'Familie' },
        { value: 'music', label: 'Music' },
        { value: 'historisch', label: 'Historisch' },
        { value: 'natuurfilm', label: 'Natuurfilm' },
        { value: 'romance', label: 'Romance' },
        { value: 'sport', label: 'Sport' },
        { value: 'kinderfilm', label: 'Kinderfilm' },
        { value: 'musical', label: 'Musical' },
        { value: 'muziek', label: 'Muziek' },
        { value: 'erotiek', label: 'Erotiek' },
        { value: 'roadmovie', label: 'Roadmovie' },
        { value: 'fantasie', label: 'Fantasie' },
        { value: 'amusement', label: 'Amusement' },
        { value: 'achtergrondinformatie', label: 'Achtergrondinformatie' },
        { value: 'experimenteel', label: 'Experimenteel' },
        { value: 'western', label: 'Western' },
        { value: 'biografisch', label: 'Biografisch' },
        { value: 'live action', label: 'Live action' },
        { value: 'zombie', label: 'Zombie' },
        { value: 'human interest', label: 'Human interest' },
        { value: 'mysterie', label: 'Mysterie' },
        { value: 'short film', label: 'Short film' },
        { value: 'pop', label: 'Pop' },
        { value: 'rock', label: 'Rock' },
        { value: 'educatief', label: 'Educatief' },
        { value: 'natuur', label: 'Natuur' },
        { value: 'film noir', label: 'Film noir' },
        { value: 'adult', label: 'Adult' },
        { value: 'nieuws / actualiteiten', label: 'Nieuws / actualiteiten' },
        { value: 'film-noir', label: 'Film-noir' },
        { value: 'news', label: 'News' },
    ];
}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/Defaults.js